
import { defineComponent, ref, reactive } from "vue";
import { menulist, menumodifyState, Addmenu, Edmenu } from "@/api/Menuconfiguration";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const tableData = ref<any>();
    const paixudispaly2 = ref(false);
    const tableColumn = ref([
      {
        prop: "menuName",
        label: "菜单名称",
      },
      {
        slotName: "accounttype",
      },
      {
        slotName: "Sort",
      },

      {
        slotName: "slotName",
      },
    ]);
    const ruleFormRef = ref<FormInstance>();
    const modelrules = reactive<FormRules>({
      menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
      menuUrl: [{ required: true, message: "请输入路径地址", trigger: "blur" }],
    });
    const SearchClass = () => {
      getzhtTable();
    };
    const zhtText = ref<any>();
    const zhtData = ref<any>({
      menuParentId: route.query.id,
    });
    const menName = ref("");
    const getzhtTable = () => {
      menulist(route.query.id, menName.value).then((res) => {
        console.log(res);
        tableData.value = res.data.list;
      });
      //   menuParentId
    };
    getzhtTable();

    const textTitle = ref<any>();
    const GooldData = ref<any>({
      command: "",
      merchantId: 0,
      resourceNo: 0,
    });
    // 主后台推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: any) => {
      console.log(row);
      GooldData.value.merchantId = row.merchantId;
      GooldData.value.resourceNo = row.id;
      zhtText.value = "启用推送后，商户端将自动接收该分类数据，并且不可逆，确认要继续吗";

      gooleshow.value = true;
    };
    const imageUrl = ref("");
    const delectImg = (val: string) => {
      imageUrl.value = val;
    };
    const changeImg = (val: any) => {
      console.log(val, "上传图片");
      imageUrl.value = val.fileUrl;
    };
    const zhtpushDisplay = () => {
      pushDisplay.value = false;
      getzhtTable();
    };
    const zhtClick = () => {
      pushDisplay.value = false;
      gooleshow.value = true;
    };
    // 谷歌
    const gooleshow = ref(false);
    // 谷歌确认
    const onconfirm = (val: any) => {
      console.log(val.ruleForm.gooleId);
      GooldData.value.command = val.ruleForm.gooleId;
      menumodifyState(GooldData.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          gooleshow.value = false;
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
          gooleshow.value = false;
        }
      });
    };

    // 排序
    const formpaixu2 = ref<any>({
      menuName: "",
      menuParentId: "",
      menuSort: "",
      id: "",
      menuType: "",
      menuUrl: "",
    });
    const zhtinputnumber2 = (row: any) => {
      console.log(row);
      paixudispaly2.value = true;
      formpaixu2.value.menuName = row.menuName;
      formpaixu2.value.menuParentId = row.menuParentId;
      formpaixu2.value.menuSort = row.menuSort;
      formpaixu2.value.id = row.id;
      formpaixu2.value.menuType = row.menuType;
      formpaixu2.value.menuUrl = row.menuUrl;
    };
    const qurenpaixudispaly2 = () => {
      Edmenu(formpaixu2.value).then((res) => {
        console.log(res);
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
        }
      });
      paixudispaly2.value = false;
    };
    const qxpaixudispaly2 = () => {
      paixudispaly2.value = false;
      getzhtTable();
    };
    // 主后台菜单编辑添加
    const FromData = ref<any>({
      menuParentId: Number(route.query.id),
      menuName: "",
      menuSort: 1,
      menuType: "DIRECTORY",
      menuUrl: "",
      id: "",
      menuIcon: "",
    });
    const EditmenuDisplay = ref<boolean>(false);
    const edit = (row: any) => {
      console.log(row);
      textTitle.value = "编辑";
      EditmenuDisplay.value = true;
      FromData.value.menuName = row.menuName;
      FromData.value.menuParentId = row.menuParentId;
      FromData.value.menuUrl = row.menuUrl;
      FromData.value.id = row.id;
      FromData.value.menuSort = row.menuSort;
      imageUrl.value = row.menuIcon;
      FromData.value.menuIcon = "";
      FromData.value.enableFlag = row.enableFlag;
      AddEd.value = "Ed";
    };
    // 编辑确认 +  添加二级菜单
    const saveEdit = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          if (AddEd.value == "add") {
            FromData.value.menuIcon = imageUrl.value;
            Addmenu(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          } else {
            FromData.value.menuIcon = imageUrl.value;
            Edmenu(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          }
        }
      });
    };

    const AddEd = ref<any>();
    // 添加二级菜单
    const addSelectone = () => {
      textTitle.value = "添加二级菜单";
      EditmenuDisplay.value = true;
      FromData.value.menuUrl = "";
      FromData.value.menuName = "";
      imageUrl.value = "";
      FromData.value.menuIcon = "";
      AddEd.value = "add";
    };

    //跳转二级
    const goTow = (row: any) => {
      console.log(row);
      router.push({ path: "/Merchantmenu/md/towthree", query: { id: row.id } });
    };
    const onClose = () => {
      // console.log(1);
      // GooldData.value.command = "";
      getzhtTable();
    };
    return {
      tableData,
      onClose,
      tableColumn,
      switchFn,
      pushDisplay,
      EditmenuDisplay,
      edit,
      FromData,
      zhtData,
      SearchClass,
      zhtpushDisplay,
      textTitle,
      zhtText,
      zhtinputnumber2,
      saveEdit,
      addSelectone,
      goTow,
      zhtClick,
      onconfirm,
      gooleshow,
      delectImg,
      changeImg,
      imageUrl,
      qurenpaixudispaly2,
      qxpaixudispaly2,
      paixudispaly2,
      ruleFormRef,
      modelrules,
    };
  },
});
